import withRouter from '@components/common/withRouter';
import { ScrollTop } from 'primereact/scrolltop';
import Header from "./Header";
import Footer from "./Footer";
import i18n from "@./i18nMain";

//css
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';

const Layout = (props) => {
    return (
        <>
            <Header />
            <main className="flex-grow-1">
				{props.children}
				<ScrollTop threshold={100} className="rounded-3 bg-secondary" />
            </main>
            <Footer />
        </>
    )
}

export default withRouter(Layout);